import { render, staticRenderFns } from "./VSwitchButton.vue?vue&type=template&id=5d0f3c82"
import script from "./VSwitchButton.vue?vue&type=script&lang=js"
export * from "./VSwitchButton.vue?vue&type=script&lang=js"
import style0 from "./VSwitchButton.vue?vue&type=style&index=0&id=5d0f3c82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports